export const numberTypeInputs = [
    "notificationTargetType"
]